<template>
  <div class="fh flex-center auth-screen-wrapper">
    <!-- The login fields area -->
    <img class="logo" src="@/assets/logo-text.png" alt="Logo" />
    <section class="sign-in-contents">
      <!-- router container -->
      <!-- router-view -->
      <router-view></router-view>
    </section>
    <!-- Router container ends -->
  </div>
</template>

<script>
export default {
  props: {
    nextUrl: String,
  },
  created() {
    // reroute to home page if the user is already logged in
    if (localStorage.getItem("token")) {
      this.$router.push("/");
    }
  },
};
</script>

<style lang="scss">
.auth-screen-wrapper {
  /* background-color: var(--color-secondary); */
  background-image: url("../../../assets/map_bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow-y: auto;
  position: relative;
}

.logo {
  position: absolute;
  top: 30px;
  height: 35px;
}

.button {
  width: 100%;
}

.concent-container {
  display: flex;

  i {
    cursor: pointer;
  }

  .concent {
    font-size: 0.9em;
    opacity: 0.8;
    margin: 0;
    line-height: 1.3em;
  }
}

.footer {
  margin-top: 25px;
  /* border-top: solid 1px red; */

  .button {
    width: auto;
  }
}

.footer-link {
  text-align: center;
}

.footer-terms {
  font-size: 0.8em;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.2em;

  a {
    opacity: 1;
    text-decoration: none;
    color: white;
  }
}

.progress-track {
  position: relative;
  background-color: var(--border-color);
  min-height: 6px;
  border-radius: 10px;
  margin-top: 5px;
  width: 150px;

  .progress-thumb {
    position: absolute;
    left: 0;
    min-height: 6px;
    border-radius: 10px;
    background-color: var(--color-primary);

    &.active {
      background-color: var(--color-accent);
      opacity: 1;
    }
  }
}

/* &:hover {
          .progress-track {
            .progress-thumb {
              background-color: var(--color-accent);
              opacity: 1;
            }
          }
        } */

.sign-in-contents {
  max-width: 400px;
  width: 100%;
  background-color: var(--color-secondary);
  border-radius: 5px;
  margin: 0 10px;
  @include respond-below(sm) {
    min-width: 0;
  }
  .item-header {
    font-size: 1.3em;
  }
  .item-subheader {
    font-size: 1em;
    opacity: 0.7;
  }
}
.auth-screen-text-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  height: 100%;
}
.welcome-text {
  font-size: 4em;
}

.help-link {
  text-decoration: none;
  color: var(--font-color);
  padding: 20px 0;
  display: inline-block;

  &:hover {
    color: var(--color-primary);
  }
}
</style>
